<div class="dx-side-navigation-menu" [ngClass]="{'dx-side-navigation-menu--mini': isMinified}">

  <!-- Шапка боковой нвигации -->
  <!-- Отображение панели с иконкой и текстом в шапке боковой навигации -->
  <div class="dx-side-navigation-menu__top" *ngIf="false">
    <a class="dx-side-navigation-menu__top_main-link">
      <i class="dx-side-navigation-menu__top_main-link-icon">
        <img [src]="''">
      </i>
      <span class="dx-side-navigation-menu__top_main-link-label">
        Управление инвестиционными проектами и программами
      </span>
    </a>
  </div>


  <!-- Основное тело боковой навигационной панели -->
  <div class="dx-side-navigation-menu__body">

    <ul class="dx-side-navigation-menu__list">
      <ng-container *ngFor="let item of items">
        <li class="dx-side-navigation-menu__list_item"
            [ngClass]="{
                          'dx-side-navigation-menu__list_item--active': isActiveItem(item),
                          'dx-side-navigation-menu__list_item--open': isExpandedItem(item)
                       }"
            (click)="onMenuItemClick(item)">

          <!-- Щапка элемента списа с иконкой и кнопкой сворчивания\разворачивания -->
          <div class="dx-side-navigation-menu__list_head">
            <!-- Кнопка сворчивания\разворачивания -->
            <div class="dx-side-navigation-menu__list_item_drop_toggle" *ngIf="item.hasChildren" (click)="onToggleDropDownPanel(item)"></div>
            <i class="dx-side-navigation-menu__list_item_icon" [title]="item.hint">
              <img [src]="item.icon">
            </i>
            <span class="dx-side-navigation-menu__list_item_label" [title]="item.hint">{{item.title}}</span>
          </div>

          <!-- Боди зполняется только для элементов имеющих детей -->
          <div class="dx-side-navigation-menu__list_body">
            <ng-container [ngSwitch]="menuTree.depth">
              <ng-container *ngSwitchCase="2">
                <dx-side-dropdown-list [menuNode]="item"
                                       (itemClick)="onSumMenuItemClick($event)">
                </dx-side-dropdown-list>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <dx-side-dropdown-tree [menuNode]="item"></dx-side-dropdown-tree>
              </ng-container>
            </ng-container>
          </div>

        </li>
      </ng-container>
    </ul>

  </div>

  <!-- Футрен навигационной панели -->
  <div class="dx-side-navigation-menu__bottom">
    <!-- Кнопка сворачивания\разоврачивания боковой навигации -->
    <div class="dx-side-navigation-menu__toggle" title="Свернуть меню" (click)="onMenuTogglerClick()"></div>
  </div>

</div>
